var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSinoSemNotificacao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#E5FFEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 36C24.896 35.9946 24.0009 35.1039 23.99 34H27.99C27.9921 34.2674 27.9411 34.5325 27.84 34.78C27.5777 35.382 27.0418 35.8211 26.4 35.96H26.395H26.38H26.362H26.353C26.2368 35.9842 26.1186 35.9976 26 36ZM34 33H18V31L20 30V24.5C19.9473 23.0891 20.2659 21.6891 20.924 20.44C21.579 19.2815 22.6987 18.4589 24 18.18V16H28V18.18C30.579 18.794 32 21.038 32 24.5V30L34 31V33Z",
    fill: "#1F9833"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinoSemNotificacao);
export default __webpack_public_path__ + "static/media/sino-sem-notificacao.762844fb.svg";
export { ForwardRef as ReactComponent };